export const DEFAULT_FETCH_ALL_LIMIT = 25;
export const COMMONMARK = 'commonmark';
